export const LICENSE_PLATE_SET_PREFERRED = 'LICENSE_PLAT_SET_PREFERRED';

export const COMPANY_NAME_FETCH_REQUEST = 'COMPANY_NAME_FETCH_REQUEST';
export const COMPANY_NAME_FETCH_SUCCESS = 'COMPANY_NAME_FETCH_SUCCESS';
export const COMPANY_NAME_FETCH_FAILED = 'COMPANY_NAME_FETCH_FAILED';

export const PROFILE_FETCH_REQUEST = 'PROFILE_FETCH_REQUEST';
export const PROFILE_FETCH_SUCCESS = 'PROFILE_FETCH_SUCCESS';
export const PROFILE_FETCH_FAILED = 'PROFILE_FETCH_FAILED';

export const PROFILE_SET_LOCALE = 'PROFILE_SET_LOCALE';